import { Alert, Card, CardActions, CardContent, Checkbox, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material';
import MButton from 'components/Mbutton';
import React, { useState } from 'react';
import { BsGit } from 'react-icons/bs';
import { getEmployerHeader } from "Constaints";
import MergeEmployee from './modals/MergeEmployee';
import { useTranslation } from "react-i18next";

const MergeEmployeeCard = ({ employees, index, fetchEMployees, setSelecetdEmployee, setOpenEmployeeModal }) => {

    const [selectedItems, setSelectedItems] = useState([]);

    const { t } = useTranslation("employes_by_enterprise");

    const handleSelect = (employee) => {

        const g = selectedItems?.find((item) => item?.id === employee?.id);
        if (g) {
            setSelectedItems(selectedItems?.filter((item) => item?.id !== employee?.id));
        } else {
            setSelectedItems([...selectedItems, employee]);
        }
    };
    const handleEndSuccess = (mergedEmployee) => {
        // console.log("🚀 ~ handleEndSuccess ~ mergedEmployee:", mergedEmployee)
        // setSelecetdEmployee(selectedItems[0])
        setSelecetdEmployee(mergedEmployee)
        setOpenEmployeeModal(true)
        setSelectedItems([])
        fetchEMployees()
    }


    const columns = getEmployerHeader(t);

    function Row(props) {
        const { row } = props;

        return (

            < React.Fragment >
                <TableRow className='flex items-center' sx={{ '& > *': { margin: 0, padding: 0 } }}>
                    <Checkbox onChange={(e) => {
                        e.preventDefault()
                        e?.stopPropagation()
                        handleSelect(row)
                    }}
                        checked={selectedItems?.includes(row)}
                        color="success"
                    />
                    {
                        Object.keys(row?.datas)?.map((key) => {
                            return (
                                <TableCell align={columns?.find((c) => c?.id == key)?.align} style={{ color: row?.color }} > {row?.datas[key] ?? "--"} </TableCell>
                            )
                        })
                    }
                </TableRow>

            </React.Fragment >
        );
    }
    const [isOpenConfirm, setisOpenConfirm] = useState(false);
    return (
        <>
            <MergeEmployee
                isOpen={isOpenConfirm}
                onClose={() => setisOpenConfirm(false)}
                selectedEployees={selectedItems}
                handleEndSuccess={handleEndSuccess}
            />
            <Card sx={{ minWidth: 275 }} className="mb-2  bg-gray-50" key={employees?.key}>

                <CardContent>
                    <div className='flex items-center justify-between'>
                        <Typography gutterBottom sx={{ fontSize: 16 }}>
                            Groupe {index + 1}
                        </Typography>
                        <div className='flex items-center gap-2'>

                            {
                                selectedItems?.length == 0 ? <Alert severity='warning' sx={{ fontSize: 16 }}>
                                    La premier selection sera considerer comme le principal
                                </Alert>
                                    :
                                    selectedItems?.length == employees?.length ? <Alert severity='success' sx={{ fontSize: 16 }}>
                                        Tous les employés de ce groupe sont sélectionnés
                                    </Alert>
                                        :
                                        <Alert severity='info' sx={{ fontSize: 16 }}>
                                            Selectionner les autres occurence similaires
                                        </Alert>
                            }

                        </div>


                        {selectedItems?.length > 0 ? <Typography gutterBottom sx={{ color: 'orange', fontSize: 16 }}>
                            {selectedItems?.length} employé(s) sélectionné(s)
                        </Typography> : <Typography gutterBottom sx={{ color: 'text.secondary', fontSize: 16 }}>
                            {employees?.length} employé(s) dans ce groupe
                        </Typography>}

                    </div>

                    <TableContainer sx={{ maxHeight: "85dvh" }}>
                        <Table stickyHeader size="small" aria-label="collapsible table">
                            <TableHead>
                                <TableRow>
                                    {columns.map((column) => (
                                        <TableCell
                                            key={column.id}
                                            align={column.align}
                                            style={{ minWidth: column.minWidth, maxWidth: column?.maxWidth }}
                                        >
                                            {column.label}
                                        </TableCell>
                                    ))}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {employees?.length > 0 && employees
                                    .map((row) => {
                                        return (
                                            <Row key={row?.name} row={row} />


                                        );
                                    })}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </CardContent>
                <CardActions className="flex justify-center">

                    {employees?.length > 0 && <MButton
                        onClick={() => setisOpenConfirm(true)}
                        disabled={selectedItems?.length < 2}
                    >
                        <BsGit color={employees[0]?.color || "red"} />
                        Fusionner ce groupe
                    </MButton>}
                </CardActions>
            </Card>
        </>

    );
}
export default MergeEmployeeCard;
